﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {
	initializeMvvmContext,
	MvvmDataProvider,
	MvvmDataProviderRef,
	MvvmOptionList
} from "@2d-front-monorepo/design-library";
import {JSX, RefObject, useMemo} from "react";
import {TariffId} from "../nominalTypes/TariffId";
import {Tariffs} from "../Tariffs";
import {IntegraHolderData} from "../types/IntegraHolderData";

export type SelectTariffComponentProps = {
	initialState: SelectTariffModel;
	onSubmit: (formData: SelectTariffModel) => Promise<void>;
	holder: IntegraHolderData;
	tariffIds: TariffId[];
	contextRef?: RefObject<MvvmDataProviderRef<SelectTariffModel>>;
	children?: JSX.Element;
}

export type SelectTariffModel = {
	tariffId: TariffId;
}

export default function SelectTariffComponent(props: SelectTariffComponentProps): JSX.Element {
	const {
		initialState,
		onSubmit,
		holder,
		tariffIds,
		contextRef,
		children
	} = props;

	const tariffs = useMemo(() => Tariffs.getAll(holder, tariffIds).map(z => ({
		label: z.title,
		value: z.type
	})), [holder, tariffIds]);

	const context = initializeMvvmContext({
		initialState: () => {
			initialState.tariffId = isNullOrEmpty(initialState.tariffId) ? tariffs[0].value : initialState.tariffId;
			return initialState;
		},
		contextRef: contextRef
	});

	return <MvvmDataProvider<SelectTariffModel> onSubmit={onSubmit} context={context}>
		<MvvmOptionList context={context} property="tariffId" items={tariffs}/>
		{children}
	</MvvmDataProvider>;
}
